<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img
          class="img-fluid"
          src="../assets/images/banner/news_banner.jpg"
          alt="banner"
        />
        <div class="banner-text">
          <h1>最新消息</h1>
          <div class="banner-text-line"></div>
          <span>Lstest News</span>
        </div>
      </div>
    </div>
    <div
      class="contentContainer-noMove"
      :style="{ backgroundImage: 'url(' + BG + ')' }"
    >
      <div class="content">
        <!-- mobile 用 -->
        <div
          v-if="screenWidth < 768"
          class="accordion mb-4 mt-4"
          id="insideMenuMobile"
        >
          <div class="card">
            <div class="card-header insideMenu-header" id="headingOne">
              <h2 class="mb-0">
                <button
                  class="btn btn-block text-left"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  {{ title }}
                  <i class="fas fa-angle-down fa-lg insideMenu-icon"></i>
                  <i class="fas fa-angle-up fa-lg insideMenu-icon"></i>
                </button>
              </h2>
            </div>

            <div
              id="collapseOne"
              class="collapse"
              aria-labelledby="headingOne"
              data-parent="#insideMenuMobile"
            >
              <div>
                <div class="list-group list-bg" id="list-tab" role="tablist">
                  <a
                    v-for="(item, index) in listTitle"
                    :key="index"
                    class="list-group-item text-center"
                    :class="{ active: title === item.titleZh }"
                    :id="item.titleEn"
                    data-toggle="list"
                    role="tab"
                    :aria-controls="item.titleEn"
                    @click="setTitle(item.titleZh)"
                    >{{ item.titleZh }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- PC 用 -->
        <div v-if="screenWidth >= 768" class="d-flex justify-content-center">
          <div
            class="list-group list-group-horizontal list-bg list-area rounded-pill"
            id="list-tab"
            role="tablist"
          >
            <a
              v-for="(item, index) in listTitle"
              :key="index"
              class="list-group-item text-center rounded-pill"
              :class="{ active: title === item.titleZh }"
              :id="item.titleEn"
              data-toggle="list"
              href="#list-announcement"
              role="tab"
              :aria-controls="item.titleEn"
              @click="setTitle(item.titleZh)"
              >{{ item.titleZh }}</a
            >
          </div>
        </div>
        <div class="tab-content" id="nav-tabContent">
          <div
            class="tab-pane fade show active"
            id="list-dentalHygienists"
            role="tabpanel"
            aria-labelledby="list-dentalHygienists-list"
          >
            <transition mode="out-in">
              <div class="no">
                <div class="announcement-wrap" v-if="filterData.length > 0">
                  <div class="announcement-listArea">
                    <div
                      class="infinite-scroll"
                      v-infinite-scroll="loadMore"
                      infinite-scroll-disabled="busy"
                      infinite-scroll-distance="0"
                    >
                      <template v-for="(item, index) in filterData">
                        <NewsList
                          :data="item"
                          :key="index"
                          :from="'news'"
                        ></NewsList>
                      </template>
                    </div>
                  </div>
                  <div class="announcement-filterArea">
                    <div class="announcement-searchBox">
                      <input type="text" v-model="searchString" />
                      <a href="#">
                        <i class="fas fa-search fa-lg"></i>
                      </a>
                    </div>
                    <!-- <div class="announcement-tag">
                      依年份搜尋
                      <ul class="announcement-tag-list list-unstyled">
                        <li>
                          <a
                            href="#"
                            class="filter-age"
                            @click.prevent="filterAge('2020')"
                            >2020</a
                          >
                        </li>
                      </ul>
                    </div> -->
                  </div>
                </div>
                <div class="content-contact" v-else>
                  <div class="content-contact-border">
                    <div class="member-box">
                      <h3>目前沒有內容</h3>
                    </div>
                  </div>
                  <div class="announcement-filterArea">
                    <div class="announcement-searchBox">
                      <input type="text" v-model="searchString" />
                      <a href="#">
                        <i class="fas fa-search fa-lg"></i>
                      </a>
                    </div>
                    <!-- <div class="announcement-tag">
                      依年份搜尋
                      <ul class="announcement-tag-list list-unstyled">
                        <li>
                          <a
                            href="#"
                            class="filter-age"
                            @click.prevent="filterAge('2020')"
                            >2020</a
                          >
                        </li>
                      </ul>
                    </div> -->
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import NewsList from '@/components/NewsList.vue';
import NewsApi from '@/assets/api/news';
import BG from '../assets/images/index_bg_big.png';
import 'vue-lazy-youtube-video/dist/style.css';

export default {
  name: 'news',
  components: {
    NewsList,
  },
  data() {
    return {
      BG,
      // screenWidth: 0,
      title: '全部消息',
      nowIndex: 0,
      searchString: '',
      searchAge: '',
      listTitle: [
        {
          titleZh: '全部消息',
          titleEn: 'all',
        },
        {
          titleZh: '學會公告',
          titleEn: 'association',
        },
        {
          titleZh: '國際訊息',
          titleEn: 'international',
        },
      ],
      news: [],
      filter: '',
      nowPage: 1,
      busy: false, // true觸發載入，false停止載入
      totalPage: 1,
    };
  },
  methods: {
    setTitle(text) {
      const vm = this;
      vm.title = text;
      // vm.searchString = '';
      $('#collapseOne').collapse('hide');
    },
    filterAge(age) {
      const vm = this;
      $('.filter-age').removeClass('active');
      // eslint-disable-next-line no-restricted-globals
      $(event.target).addClass('active');
      vm.searchAge = age;
    },
    getNews(page) {
      const vm = this;
      NewsApi.getAllNews(page).then((res) => {
        if (res.status === 200) {
          if (vm.news.length === 0) {
            vm.news = res.data.Data.News;
            vm.totalPage = Math.ceil(parseInt(res.data.Data.Total, 10) / 10); // 指定為10進位
          } else {
            vm.busy = false;
            vm.$store.dispatch('updateLoading', false);
            vm.news = vm.news.concat(res.data.Data.News);
          }
        }
      });
    },
    loadMore() {
      const vm = this;
      vm.busy = true;
      if (vm.totalPage === 1 || vm.totalPage === vm.nowPage) {
        vm.busy = false;
      } else {
        vm.$store.dispatch('updateLoading', true);
        vm.nowPage += 1;
        vm.getNews(vm.nowPage);
      }
    },
    // search(string) {
    //   const vm = this;
    //   if (string === '') {
    //     console.log('空的');
    //   } else {
    //     // vm.news = vm.news.filter((item) => item.Title.indexOf(vm.searchString) !== -1);
    //   }
    // },
  },
  created() {
    const vm = this;
    vm.getNews(vm.nowPage);
    // vm.news = [
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '視網膜醫學會網站 全新改版，會員/準會員 登入說明～',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //     // eslint-disable-next-line global-require
    //     Image: require('@/assets/images/continuing_pic.jpg'),
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '中華民國視網膜醫學會 民國108年 工作計畫',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: 'abcdefsdasdsdadsadasdasd',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '國際訊息',
    //     Title: '轉知「醫策會20週年國際論壇」徵文訊息。',
    //     CategoryId: '8f7587e8-3649-4dce-a525-c7a54499841d',
    //   },
    //   {
    //     Id: 'abcdefsdasdsdadsadasdasd',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '視網膜醫學會網站 全新改版，會員/準會員 登入說明～',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '視網膜醫學會網站 全新改版，會員/準會員 登入說明～',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '中華民國視網膜醫學會 民國108年 工作計畫',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: 'abcdefsdasdsdadsadasdasd',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '國際訊息',
    //     Title: '轉知「醫策會20週年國際論壇」徵文訊息。',
    //     CategoryId: '8f7587e8-3649-4dce-a525-c7a54499841d',
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '視網膜醫學會網站 全新改版，會員/準會員 登入說明～',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '中華民國視網膜醫學會 民國108年 工作計畫',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: 'abcdefsdasdsdadsadasdasd',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '國際訊息',
    //     Title: '轉知「醫策會20週年國際論壇」徵文訊息。',
    //     CategoryId: '8f7587e8-3649-4dce-a525-c7a54499841d',
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2018-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '視網膜醫學會網站 全新改版，會員/準會員 登入說明～',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '中華民國視網膜醫學會 民國108年 工作計畫',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: 'abcdefsdasdsdadsadasdasd',
    //     StartOn: '2020-01-07',
    //     EndOn: '',
    //     Sort: '國際訊息',
    //     Title: '轉知「醫策會20週年國際論壇」徵文訊息。安安',
    //     CategoryId: '8f7587e8-3649-4dce-a525-c7a54499841d',
    //   },
    // ];
  },
  computed: {
    filterData() {
      const vm = this;
      let returnData = [];

      const filterByCategory = (category) => vm.news.filter(
        (item) => item.Categories.indexOf(category) !== -1,
      );

      const applyFilters = (data) => {
        let filteredData = data; // 新增一個新的變數保存篩選後的資料
        if (vm.searchString !== '') {
          filteredData = filteredData.filter(
            (item) => item.Title.indexOf(vm.searchString) !== -1,
          );
        }
        if (vm.searchAge !== '') {
          filteredData = filteredData.filter(
            (item) => item.CreatedOn.indexOf(vm.searchAge) !== -1,
          );
        }
        return filteredData;
      };

      if (vm.title === '全部消息') {
        returnData = vm.news;
      } else if (vm.title === '學會公告') {
        returnData = filterByCategory(1);
      } else if (vm.title === '國際訊息') {
        returnData = filterByCategory(3);
      }

      return applyFilters(returnData);
    },
    // setList() {
    //   const vm = this;
    //   return vm.answerData[vm.nowIndex];
    // },
    screenWidth() {
      return this.$store.state.screenWidth;
    },
  },
};
</script>

<style lang="scss">
.list-bg {
  a {
    cursor: pointer;
  }
}
</style>
